var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSignLanguageFlag = function SvgSignLanguageFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1613",
    "data-name": "Ret\\xE2ngulo 1613",
    width: 27.276,
    height: 28.285,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5834",
    "data-name": "Grupo 5834",
    transform: "translate(-80 -1481.531)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1612",
    "data-name": "Ret\\xE2ngulo 1612",
    width: 35,
    height: 35,
    rx: 5,
    transform: "translate(80 1481.531)",
    fill: "#0a5499"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5833",
    "data-name": "Grupo 5833",
    transform: "translate(84.463 1485.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5832",
    "data-name": "Grupo 5832",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4407",
    "data-name": "Caminho 4407",
    d: "M5.02,17.751a22.405,22.405,0,0,1-1.071-4.41,8.421,8.421,0,0,0-1.7-3.227,30.078,30.078,0,0,1-2.2-3.523.638.638,0,0,1,.6-.846.707.707,0,0,1,.521.261c.6.664,2.754,3.337,3.073,3.654a1.12,1.12,0,0,0,.656.317c.257,0,.412-.238.1-1.039C4.43,7.458,2.892,4.187,2.587,3.405c-.433-1.11.207-1.2.207-1.2A.756.756,0,0,1,3.2,2.066a.633.633,0,0,1,.548.364c.394.653,2.667,5.24,2.952,5.647.139.2.3.341.416.341s.212-.154.2-.556c-.025-.788-.342-5.477-.527-7.019-.066-.549.523-.824.8-.842H7.61a1.026,1.026,0,0,1,.8.643c.106.339,1.036,6.165,1.131,6.9.052.4.269.688.483.688.179,0,.356-.2.434-.707.171-1.112,1.1-5.612,1.191-6.184A.629.629,0,0,1,12.3.718a1.116,1.116,0,0,1,.219.023.766.766,0,0,1,.659.818c-.019.422-.489,6.091-.409,8.014a15.841,15.841,0,0,1-2.092.724l-.061.016-.06.022-.355.13c-.068.008-.2.014-.29.019a2.263,2.263,0,0,0-2.1.987,1.69,1.69,0,0,0-.089,1.406A2.726,2.726,0,0,0,9.29,14.3l.07.028a4.2,4.2,0,0,0,1.794.3c.478,0,1.073-.033,1.817-.1-.134.328-.328.712-.445.944l-.1.206a44.031,44.031,0,0,1-2.993,4.175,7.417,7.417,0,0,0-.857-.049,8.89,8.89,0,0,0-1.473.129,3.131,3.131,0,0,1-2.08-2.185",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4408",
    "data-name": "Caminho 4408",
    d: "M56.1,45.69a22.385,22.385,0,0,1-1.551,4.265,8.419,8.419,0,0,0-.373,3.628,30.2,30.2,0,0,1-.118,4.153.6.6,0,0,1-.623.474.635.635,0,0,1-.632-.606c-.136-.888-.445-4.3-.535-4.744-.052-.257-.277-.679-.524-.679-.177,0-.364.215-.508.86-.347,1.546-.877,5.122-1.055,5.941-.172.789-.5.916-.686.916a.387.387,0,0,1-.152-.029h-.021a.623.623,0,0,1-.652-.72c.034-.763.681-5.84.669-6.336-.007-.3-.082-.538-.232-.538-.1,0-.232.107-.4.375-.416.67-2.749,4.75-3.449,6.136a.7.7,0,0,1-.661.371,1,1,0,0,1-.467-.11,1.01,1.01,0,0,1-.326-.988c.1-.341,2.553-5.707,2.878-6.368.217-.441.138-.881-.162-.881a.955.955,0,0,0-.611.389c-.759.831-4.028,4.062-4.417,4.489a.71.71,0,0,1-.523.274.782.782,0,0,1-.536-.262.767.767,0,0,1-.1-1.046c.268-.366,4.309-5.469,4.955-6.759.611-1.221,1.68-3.114-.324-3.114q-.169,0-.369.018c-.792.073-1.359.1-1.776.1a2.868,2.868,0,0,1-1.387-.24c-.411-.157-.972-.569-.77-.946s1.2-.207,1.611-.356l.409-.15a15.146,15.146,0,0,0,2.965-1.128,25.394,25.394,0,0,1,4.427-1.893,5.47,5.47,0,0,1,.968-.085,3.2,3.2,0,0,1,1.236.2c.535.242,1.062,1.416,3.295,2.415A3.134,3.134,0,0,1,56.1,45.69",
    transform: "translate(-31.671 -31.613)",
    fill: "#fff"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignLanguageFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sign-language-flag.a26890b7.svg";
export { ForwardRef as ReactComponent };